import { colors } from 'fitify-ui/src/theme/colors'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { getMuscleI18nKey } from '@/utils/exercises'

import { IntensityIndicator } from '../IntensityIndicator/IntensityIndicator'
import {
  getActiveDots,
  type IntensityVariant,
  type MuscleEntry,
} from '../Muscles.Utils'

import {
  StyledContainer,
  StyledList,
  StyledMuscleItem,
} from './MuscleList.Styled'

type Props = {
  label: string
  muscles: MuscleEntry[]
  variant: IntensityVariant
}

export const MuscleList = ({ label, muscles, variant }: Props) => {
  const { t } = useTranslation()

  const filteredMuscles = useMemo(() => {
    return muscles.filter((muscle) => {
      return getActiveDots(muscle.intensity) > 1
    })
  }, [muscles])

  if (filteredMuscles.length === 0) return null

  return (
    <StyledContainer>
      <Typography as="h3" $color={colors.Gray700} $variant="Headline/H 16">
        {label}
      </Typography>
      <StyledList>
        {filteredMuscles.map((muscle) => (
          <StyledMuscleItem key={muscle.key}>
            <Typography $color={colors.Black} $variant="Special/Label 12">
              {t(getMuscleI18nKey(muscle.key))}
            </Typography>
            <IntensityIndicator
              intensity={muscle.intensity}
              variant={variant}
            />
          </StyledMuscleItem>
        ))}
      </StyledList>
    </StyledContainer>
  )
}
